<template>
<div container--fluid>
    <v-layout>
        <InvoicePaymentModule :invoice-id="invoice_id"></InvoicePaymentModule>
    </v-layout>
</div>
</template>

<script>
import InvoicePaymentModule from '@modules/invoice/payment.vue';

export default {
    name: 'InvoicePayment',
    components: {
        InvoicePaymentModule,
    },
    props: {
        'invoice_id': {
            type: [Number, String],
            required: true
        }
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
